import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenominationChurchesPublic = ({ denominationId }) => {
  return axios.get(
    `/denominations/${denominationId}/denomination-churches/public`
  );
};

export const useDenominationChurchesPublic = ({
  denominationId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["denomination-churches-public", denominationId],
    queryFn: () => getDenominationChurchesPublic({ denominationId })
  });
};
